<main class="bg-background-light dark:bg-background-dark dark:text-white flex-1 p-8">
  <!-- Show video list if no video is selected -->
  <div *ngIf="!selectedVideo" class="flex flex-col gap-8">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      <div
        *ngFor="let video of videos"
        class="bg-white dark:bg-card-dark rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-3 flex flex-col cursor-pointer group"
        (click)="selectVideo(video)"
      >
        <!-- Thumbnail Section -->
        <div class="relative w-full h-40 mb-4 overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-800">
          <img
            [src]="video.thumbnail || 'https://via.placeholder.com/400x200'"
            [alt]="'Thumbnail for ' + video.title"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />

          <!-- Play Button Overlay (hidden by default, visible on hover) -->
          <div
            class="absolute inset-0 bg-black/10 group-hover:bg-black/25 transition-all duration-300 flex items-center justify-center"
          >
            <div
              class="opacity-0 group-hover:opacity-100 transform scale-90 group-hover:scale-100 transition-all duration-300 w-14 h-14 rounded-full bg-accent/80 flex items-center justify-center"
            >
              <span class="material-symbols-outlined text-white text-4xl">
                play_arrow
              </span>
            </div>
          </div>
        </div>

        <!-- Title -->
        <h3
          class="text-lg font-semibold text-text-light dark:text-text-dark line-clamp-2 mb-2"
          title="{{ video.title }}"
        >
          {{ video.title }}
        </h3>

        <!-- Description -->
        <p
          class="text-sm text-subtext-light dark:text-subtext-dark line-clamp-2 flex-grow mb-4"
          title="{{ video.description }}"
        >
          {{ video.description }}
        </p>

        <!-- Duration & Views -->
        <div class="flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 mb-3">
          <span class="flex items-center gap-1">
            <span class="material-symbols-outlined text-base">schedule</span>
            {{ video.duration | duration }}
          </span>
          <span class="flex items-center gap-1">
            <span class="material-symbols-outlined text-base">visibility</span>
            {{ video.views }} views
          </span>
        </div>

        <!-- Uploaded Date -->
        <p class="text-xs text-subtext-light dark:text-subtext-dark mb-4">
          Uploaded: {{ video.date }}
        </p>
      </div>
    </div>

    <p *ngIf="videos.length === 0" class="text-center text-gray-500 dark:text-gray-400 mt-8">
      No videos found.
    </p>

    <div class="mt-8 flex justify-center" *ngIf="videos.length > 0">
      <app-pagination
        [currentPage]="currentPage"
        [totalPages]="Math.ceil(totalCount / limit)"
        [limit]="limit"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-pagination>
    </div>
  </div>

  <!-- Show video player if a video is selected -->
  <app-video-player
    *ngIf="selectedVideo"
    [selectedVideo]="selectedVideo"
    [upNextVideos]="getUpNextVideos()"
    (playVideoChange)="selectVideo($event)"
  ></app-video-player>

  <!-- Back button -->
  <button
    *ngIf="selectedVideo"
    class="w-fit mt-4 bg-primary text-white font-semibold py-2 px-6 rounded-lg hover:bg-primary/90 transition cursor-pointer"
    (click)="clearSelection()"
  >
    ← Back to Videos
  </button>
</main>
